var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@mui/material/styles/styled';
import Button from '../Button';
import IconButton from '../IconButton';
import Box from '../Box';
import Popactions from '../Popactions';
var buttonComponents = {
    'IconButton': IconButton,
    'Button': Button,
};
var ActionsRoot = styled(Box)(function (_a) {
    var spacing = _a.spacing;
    return ({
        display: 'flex',
        alignItems: 'center',
        '&>button': {
            marginLeft: spacing,
        },
        '&>div': {
            marginLeft: spacing,
        },
        '&>*:first-child': {
            marginLeft: 0
        },
    });
});
var Action = function (_a) {
    var spacing = _a.spacing, actions = _a.actions, data = _a.data;
    var actionBtns = actions.map(function (actionsItems) {
        var text = actionsItems.text, subActons = actionsItems.actions, _a = actionsItems.buttonType, buttonType = _a === void 0 ? 'Button' : _a, onClick = actionsItems.onClick, isHiddenFn = actionsItems.isHiddenFn, buttonProps = __rest(actionsItems, ["text", "actions", "buttonType", "onClick", "isHiddenFn"]);
        if (isHiddenFn && isHiddenFn(data))
            return null;
        var handleClick = function (event) {
            var _a;
            (_a = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
            onClick === null || onClick === void 0 ? void 0 : onClick(data);
        };
        var ButtonComponent = buttonComponents[buttonType];
        var children = (React.createElement(ButtonComponent, __assign({ onClick: handleClick }, buttonProps), buttonType === 'Button' ? text : buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.icon));
        if (subActons && subActons.length > 0) {
            return (React.createElement(Popactions, { key: text, actions: subActons }, children));
        }
        return children;
    });
    return (React.createElement(ActionsRoot, { spacing: spacing }, actionBtns));
};
Action.defaultProps = {
    actions: [],
    spacing: '7px',
    buttonType: 'Button',
};
export default Action;
